import { alpha, Box, Stack, Typography, useTheme } from "@mui/material";
import type { FC, ReactNode } from "react";
import { DashboardRowGlyph } from "web_myplann/Dashboard/Components/DashboardRowGlyph";
import { getSvgDataUri } from "web_myplann/Shared/Utils/getSvgDataUri";

const ICON_SIZE = 40;
const ICON_RADIUS = "12px";
const TINT_OPACITY = 0.16;

type Props = {
	icon?: string | ReactNode | null;
	iconText?: string;
	iconColor?: string;
};

export const DashboardDetailRowIcon: FC<Props> = ({
	icon,
	iconText,
	iconColor,
}) => {
	const { palette } = useTheme();

	const logoUri = getSvgDataUri(icon);
	const tintBase = iconColor ?? palette.grey[600];

	return (
		<Stack
			alignItems="center"
			justifyContent="center"
			width={ICON_SIZE}
			height={ICON_SIZE}
			flexShrink={0}
			borderRadius={ICON_RADIUS}
			overflow="hidden"
			bgcolor={
				logoUri ? palette.darkmodeText.white : alpha(tintBase, TINT_OPACITY)
			}
		>
			{logoUri && (
				<Box
					component="img"
					src={logoUri}
					alt={iconText}
					width={ICON_SIZE}
					height={ICON_SIZE}
					display="block"
				/>
			)}
			{!logoUri && icon && <DashboardRowGlyph>{icon}</DashboardRowGlyph>}
			{!logoUri && !icon && (
				<Typography variant="bodyStrong" color={tintBase}>
					{iconText}
				</Typography>
			)}
		</Stack>
	);
};
